import {useMutation} from "@apollo/client";
import {ReplaceFileDocument, ReplaceFileInput} from "generated/graphql";

export const useReplaceFile = () => {
  const [mutate] = useMutation(ReplaceFileDocument);

  return (input: ReplaceFileInput) => mutate({ variables: { input} });
}